import { render } from "./RightNav.vue?vue&type=template&id=52e5ca94&scoped=true"
import script from "./RightNav.vue?vue&type=script&lang=js"
export * from "./RightNav.vue?vue&type=script&lang=js"

import "./RightNav.vue?vue&type=style&index=0&id=52e5ca94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5ca94"]])

export default __exports__